/**
 * Local worker fixtures for booking-review assignment UI.
 * Replace with API data when the worker list endpoint is available.
 */

export const MOCK_WORKERS = [
  {
    slug: "mock-worker-amina-khan",
    workerId: "WK-1001",
    fullName: "Amina Khan",
    email: "amina.khan@example.com",
    photo: "",
    experienceLevel: "Highly Experienced",
    eligibleRoleSlugs: [
      "care-assistant-9",
      "support-worker-14",
      "youth-support-worker-15",
    ],
    certSlugs: ["dbs", "care_certificate-14", "safeguarding-20", "manual_handling-9"],
    dbsType: "enhanced",
    workForce: "child",
    availableDates: [
      "2026-07-20",
      "2026-07-21",
      "2026-07-22",
      "2026-07-23",
      "2026-07-24",
      "2026-07-27",
      "2026-07-28",
      "2026-07-29",
      "2026-07-30",
      "2026-07-31",
      "2026-08-03",
      "2026-08-04",
    ],
    distanceKm: 3.2,
    rating: 4.8,
    reliability: 97,
    locationLabel: "Tower Hamlets, London",
    summary: "Experienced care & youth support worker with Enhanced DBS.",
  },
  {
    slug: "mock-worker-james-obrien",
    workerId: "WK-1002",
    fullName: "James O'Brien",
    email: "james.obrien@example.com",
    photo: "",
    experienceLevel: "Competent",
    eligibleRoleSlugs: [
      "warehouse-operative-10",
      "forklift-driver-(-reach-)-5",
      "production-operative-11",
      "general-labourer-19",
    ],
    certSlugs: [
      "manual_handling-9",
      "health_and_safety_awareness-18",
      "forklift_reach-23",
      "cscs-10",
    ],
    dbsType: "",
    workForce: "",
    availableDates: [
      "2026-07-20",
      "2026-07-21",
      "2026-07-22",
      "2026-07-23",
      "2026-07-24",
      "2026-07-27",
      "2026-07-28",
      "2026-07-29",
      "2026-07-30",
      "2026-08-03",
      "2026-08-04",
      "2026-08-05",
    ],
    distanceKm: 5.1,
    rating: 4.5,
    reliability: 94,
    locationLabel: "Barking, London",
    summary: "Warehouse & industrial operative with forklift reach ticket.",
  },
  {
    slug: "mock-worker-sofia-martinez",
    workerId: "WK-1003",
    fullName: "Sofia Martinez",
    email: "sofia.martinez@example.com",
    photo: "",
    experienceLevel: "Developing Experience",
    eligibleRoleSlugs: [
      "waiting-staff-18",
      "bar-staff-18",
      "housekeeper-13",
      "commercial-office-cleaner-13",
    ],
    certSlugs: ["food_hygiene-11", "manual_handling-9", "first_aid-13"],
    dbsType: "basic",
    workForce: "",
    availableDates: [
      "2026-07-21",
      "2026-07-22",
      "2026-07-23",
      "2026-07-24",
      "2026-07-25",
      "2026-07-26",
      "2026-07-31",
      "2026-08-01",
      "2026-08-02",
    ],
    distanceKm: 7.8,
    rating: 4.2,
    reliability: 90,
    locationLabel: "Croydon, London",
    summary: "Hospitality & facilities worker, weekends preferred.",
  },
  {
    slug: "mock-worker-david-chen",
    workerId: "WK-1004",
    fullName: "David Chen",
    email: "david.chen@example.com",
    photo: "",
    experienceLevel: "Competent",
    eligibleRoleSlugs: [
      "retail-assistant-6",
      "shop-floor-assistant-7",
      "receptionist-12",
    ],
    certSlugs: ["health_and_safety_awareness-18", "fire_safety-22", "nvq-15"],
    dbsType: "basic",
    workForce: "",
    availableDates: [
      "2026-07-20",
      "2026-07-21",
      "2026-07-22",
      "2026-07-23",
      "2026-07-24",
      "2026-07-27",
      "2026-07-28",
      "2026-07-29",
      "2026-07-30",
      "2026-07-31",
    ],
    distanceKm: 2.4,
    rating: 4.6,
    reliability: 95,
    locationLabel: "Shoreditch, London",
    summary: "Retail floor specialist with strong customer service record.",
  },
  {
    slug: "mock-worker-priya-sharma",
    workerId: "WK-1005",
    fullName: "Priya Sharma",
    email: "priya.sharma@example.com",
    photo: "",
    experienceLevel: "Highly Experienced",
    eligibleRoleSlugs: [
      "care-assistant-9",
      "support-worker-14",
      "youth-support-worker-15",
      "steward-(non-security)-18",
    ],
    certSlugs: [
      "dbs",
      "care_certificate-14",
      "safeguarding-20",
      "first_aid-13",
      "manual_handling-9",
    ],
    dbsType: "enhancedPlus",
    workForce: "both",
    availableDates: [
      "2026-07-20",
      "2026-07-21",
      "2026-07-22",
      "2026-07-23",
      "2026-07-24",
      "2026-07-27",
      "2026-07-28",
      "2026-07-29",
      "2026-07-30",
      "2026-07-31",
      "2026-08-03",
      "2026-08-04",
      "2026-08-05",
    ],
    distanceKm: 4.0,
    rating: 4.9,
    reliability: 98,
    locationLabel: "Hackney, London",
    summary: "Senior support worker with Enhanced + Barred List DBS.",
  },
  {
    slug: "mock-worker-liam-wright",
    workerId: "WK-1006",
    fullName: "Liam Wright",
    email: "liam.wright@example.com",
    photo: "",
    experienceLevel: "New to Sector",
    eligibleRoleSlugs: [
      "general-labourer-19",
      "warehouse-operative-10",
      "commercial-office-cleaner-13",
    ],
    certSlugs: ["manual_handling-9", "health_and_safety_awareness-18"],
    dbsType: "basic",
    workForce: "",
    availableDates: [
      "2026-07-22",
      "2026-07-23",
      "2026-07-24",
      "2026-07-27",
      "2026-07-28",
      "2026-07-29",
      "2026-07-30",
      "2026-07-31",
    ],
    distanceKm: 9.5,
    rating: 3.9,
    reliability: 86,
    locationLabel: "Romford, London",
    summary: "Entry-level labourer building experience across sites.",
  },
  {
    slug: "mock-worker-emily-brooks",
    workerId: "WK-1007",
    fullName: "Emily Brooks",
    email: "emily.brooks@example.com",
    photo: "",
    experienceLevel: "Competent",
    eligibleRoleSlugs: [
      "grounds-staff-17",
      "steward-(non-security)-18",
      "care-assistant-9",
    ],
    certSlugs: ["dbs", "first_aid-13", "coshh-19"],
    dbsType: "basic",
    workForce: "",
    availableDates: [
      "2026-07-20",
      "2026-07-21",
      "2026-07-24",
      "2026-07-25",
      "2026-07-26",
      "2026-07-27",
      "2026-08-01",
      "2026-08-02",
      "2026-08-03",
    ],
    distanceKm: 6.3,
    rating: 4.4,
    reliability: 92,
    locationLabel: "Greenwich, London",
    summary: "Community & events steward with Basic DBS clearance.",
  },
  {
    slug: "mock-worker-noah-patel",
    workerId: "WK-1008",
    fullName: "Noah Patel",
    email: "noah.patel@example.com",
    photo: "",
    experienceLevel: "Highly Experienced",
    eligibleRoleSlugs: [
      "van-driver-5",
      "warehouse-operative-10",
      "forklift-driver-(-reach-)-5",
    ],
    certSlugs: [
      "driving_licence-21",
      "manual_handling-9",
      "health_and_safety_awareness-18",
      "forklift_certificate-17",
    ],
    dbsType: "",
    workForce: "",
    availableDates: [
      "2026-07-20",
      "2026-07-21",
      "2026-07-22",
      "2026-07-23",
      "2026-07-24",
      "2026-07-27",
      "2026-07-28",
      "2026-07-29",
      "2026-07-30",
      "2026-07-31",
      "2026-08-03",
      "2026-08-04",
    ],
    distanceKm: 8.1,
    rating: 4.7,
    reliability: 96,
    locationLabel: "Ilford, London",
    summary: "Reliable van & forklift driver covering East London.",
  },
  {
    slug: "mock-worker-chloe-nguyen",
    workerId: "WK-1009",
    fullName: "Chloe Nguyen",
    email: "chloe.nguyen@example.com",
    photo: "",
    experienceLevel: "Developing Experience",
    eligibleRoleSlugs: [
      "receptionist-12",
      "retail-assistant-6",
      "waiting-staff-18",
    ],
    certSlugs: ["cv-12", "first_aid-13", "nvq-15"],
    dbsType: "",
    workForce: "",
    availableDates: [
      "2026-07-21",
      "2026-07-22",
      "2026-07-23",
      "2026-07-24",
      "2026-07-28",
      "2026-07-29",
      "2026-07-30",
      "2026-07-31",
    ],
    distanceKm: 4.7,
    rating: 4.1,
    reliability: 88,
    locationLabel: "Islington, London",
    summary: "Front-of-house and admin support covering office hours.",
  },
  {
    slug: "mock-worker-marcus-reid",
    workerId: "WK-1010",
    fullName: "Marcus Reid",
    email: "marcus.reid@example.com",
    photo: "",
    experienceLevel: "Competent",
    eligibleRoleSlugs: [
      "labourer-(cscs)-8",
      "general-labourer-19",
      "machine-assistant-16",
    ],
    certSlugs: [
      "cscs-10",
      "manual_handling-9",
      "health_and_safety_awareness-18",
      "nvq-15",
    ],
    dbsType: "",
    workForce: "",
    availableDates: [
      "2026-07-20",
      "2026-07-21",
      "2026-07-22",
      "2026-07-23",
      "2026-07-24",
      "2026-07-27",
      "2026-07-28",
      "2026-07-29",
      "2026-07-30",
      "2026-07-31",
      "2026-08-03",
      "2026-08-04",
      "2026-08-05",
    ],
    distanceKm: 11.2,
    rating: 4.3,
    reliability: 91,
    locationLabel: "Lewisham, London",
    summary: "CSCS labourer with manufacturing & site experience.",
  },
  {
    slug: "mock-worker-hana-ali",
    workerId: "WK-1011",
    fullName: "Hana Ali",
    email: "hana.ali@example.com",
    photo: "",
    experienceLevel: "Competent",
    eligibleRoleSlugs: [
      "care-assistant-9",
      "support-worker-14",
      "housekeeper-13",
    ],
    certSlugs: ["dbs", "care_certificate-14", "manual_handling-9"],
    dbsType: "enhanced",
    workForce: "adult",
    availableDates: [
      "2026-07-20",
      "2026-07-21",
      "2026-07-22",
      "2026-07-23",
      "2026-07-27",
      "2026-07-28",
      "2026-07-29",
      "2026-07-30",
      "2026-08-03",
      "2026-08-04",
    ],
    distanceKm: 5.6,
    rating: 4.5,
    reliability: 93,
    locationLabel: "Newham, London",
    summary: "Care assistant with Enhanced DBS for adult workforce.",
  },
  {
    slug: "mock-worker-owen-fraser",
    workerId: "WK-1012",
    fullName: "Owen Fraser",
    email: "owen.fraser@example.com",
    photo: "",
    experienceLevel: "Highly Experienced",
    eligibleRoleSlugs: [
      "bar-staff-18",
      "waiting-staff-18",
      "steward-(non-security)-18",
    ],
    certSlugs: ["food_hygiene-11", "first_aid-13", "dbs"],
    dbsType: "basic",
    workForce: "",
    availableDates: [
      "2026-07-24",
      "2026-07-25",
      "2026-07-26",
      "2026-07-31",
      "2026-08-01",
      "2026-08-02",
      "2026-08-07",
      "2026-08-08",
      "2026-08-09",
    ],
    distanceKm: 3.8,
    rating: 4.6,
    reliability: 94,
    locationLabel: "Southwark, London",
    summary: "Events & hospitality lead covering evenings and weekends.",
  },
];
